import { useEffect, useState } from "react";

export const platform = () => {
  const ua = window.navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

export const isStandalone = () =>
  !!(window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);

// Registrato all'avvio: il browser offre l'installazione una sola volta, la teniamo da parte.
export const captureInstallPrompt = () => {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__installPrompt = e;
    window.dispatchEvent(new Event("install-ready"));
  });
  window.addEventListener("appinstalled", () => {
    window.__installPrompt = null;
    window.dispatchEvent(new Event("install-ready"));
  });
};

export const useInstall = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const on = () => tick((n) => n + 1);
    window.addEventListener("install-ready", on);
    return () => window.removeEventListener("install-ready", on);
  }, []);
  const deferred = window.__installPrompt;
  const prompt = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const choice = await deferred.userChoice.catch(() => null);
    window.__installPrompt = null;
    tick((n) => n + 1);
    return choice?.outcome === "accepted";
  };
  return { canPrompt: !!deferred, installed: isStandalone(), platform: platform(), prompt };
};
